export default "__VITE_ASSET__83b4044b__"